import React from "react";

import ApiImage from "@common/assets/images/icon-api.png";
import Button from "@common/components/Button/Button";
import { ModalProps } from "@common/components/Modal/Modal";
import { ModalHeaderProps } from "@common/components/Modal/ModalHeader/ModalHeader";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";

import * as Styled from "./ModalBody.styles";

interface Props {
  startTrial: () => void;
  loading: boolean;
  Modal: React.ForwardRefExoticComponent<ModalProps & ModalHeaderProps & React.RefAttributes<unknown>>;
  internalProps?: ModalProps;
}

export default function RestApiTrialModalBody({ startTrial, loading, Modal, internalProps }: Props) {
  const handleStartTrial = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.preventDefault();
    startTrial();
  };

  return (
    <Modal
      {...internalProps}
      heading="Create REST API keye"
      buttonElement={
        <Button
          type="button"
          size="small"
          disabled={loading}
          loadingText={loading && "Starting..."}
          onClick={(e) => handleStartTrial(e)}
        >
          Start free trial
        </Button>
      }
    >
      <Flex $column>
        <img
          style={{ alignSelf: "center", marginBottom: "2.4rem", height: "5.4rem" }}
          src={ApiImage}
          alt="API"
        />
        <Styled.Subtitle>
          Pull tickets, crash reports and user data directly into your own tools — no manual exports.{"\n"}
          Popular use cases: push to internal dashboards, sync with custom workflows, automate reporting.{"\n"}
          Available on Organization plan. Trial is free for 30 days.
        </Styled.Subtitle>
      </Flex>
    </Modal>
  );
}
